module.exports = __webpack_public_path__ + "static/media/triki-buttons.dcc87641.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/icons/svg/triki-buttons.svg
// module id = 417
// module chunks = 0